import React, { useState, useEffect, useMemo } from "react";
import "./tournament-elite.css";
import Jersey from "./assets/images/OFFICIAL_JERSEY.jpg"
import Jersey2 from "./assets/images/OFFICIAL_JERSEY.jpg"
import Sibol from "./assets/images/SIBOL_LOGO.png"
import SibolIcon from "./assets/images/SIBOL_ICON_WHT.png"
import VideoBG from "./assets/videos/sibol2.mp4"
import { db } from "../../firebase";
import { collection, addDoc, query, where, getDocs, doc, updateDoc, orderBy } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import AppHeader from "../../components/layout/AppHeader"
import BottomNav from "../../components/layout/BottomNav"
import { CLUB_ID, THEME_COLOR } from "../../config/club";
import { useAuth } from "../../context/AuthContext";
import QR1099 from "./assets/images/QR_1099.jpg";
import QR1199 from "./assets/images/QR_1199.jpg";
import AuthLanding from "../../components/player/AuthLanding";
import Swal from "sweetalert2";

const FloatingBloom = () => {
    const flowerTypes = ['🌸', '🌺', '🌷', '✨', '•'];

    const petals = useMemo(() => {
        return Array.from({ length: 24 }).map((_, i) => ({
            id: i,
            left: `${Math.random() * 100}%`,
            delay: `${Math.random() * 20}s`,
            size: `${Math.random() * 25 + 10}px`,
            opacity: Math.random() * 0.5 + 0.2,
            flower: flowerTypes[i % flowerTypes.length],
        }));
    }, []);

    return (
        <div className="bloom-container">
            <div className="glow-orb" style={{ top: '5%', left: '10%' }}></div>
            <div className="glow-orb" style={{ top: '40%', right: '15%', animationDelay: '3s', width: '300px' }}></div>
            <div className="glow-orb" style={{ bottom: '5%', left: '20%', animationDelay: '5s' }}></div>

            {petals.map((p) => (
                <span
                    key={p.id}
                    className="petal"
                    style={{
                        left: p.left,
                        animationDelay: p.delay,
                        fontSize: p.size,
                        opacity: p.opacity,
                    }}
                >
                    {p.flower}
                </span>
            ))}
        </div>
    );
};

const Toast = Swal.mixin({
    toast: true,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

const ToastShow = (type, message) =>
    Toast.fire({ icon: type, title: message });

export default function SibolRegistration() {
    const eventEnded = true;
    const gcashNum = "09970985227";
    const gcashName = "Manuel Christian M.";
    const levels = ["G - Novice", "F - Beginner", "E - High Beginner", "D - Low Intermediate", "C - Intermediate", "B - High Intermediate", "A - Advanced"];
    const { user, loading, loginGoogle, logout } = useAuth();
    const [step, setStep] = useState(1);
    const [level, setLevel] = useState(`Level ${levels[user?.level - 1]}` || "");
    const previewType = 'primary';
    const [zoomedImage, setZoomedImage] = useState(null);
    const [showSizeChart, setShowSizeChart] = useState(false);
    const [errors, setErrors] = useState({});
    const [paymentMethod, setPaymentMethod] = useState('now');
    const [regloading, setregLoading] = useState(false);
    const [existingReg, setExistingReg] = useState(null);
    const [checking, setChecking] = useState(true);
    const [payLoading, setPayLoading] = useState(false);
    const [gcashRefInput, setGcashRefInput] = useState("");
    const [payError, setPayError] = useState("");
    const [showQRModal, setShowQRModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(null);
    const [isLaunched, setIsLaunched] = useState(false);
    const isRegistrationClosed = true;
    const [loggingIn, setLoggingIn] = useState(false);

    useEffect(() => {
        const targetDate = new Date("March 28, 2026 00:00:00").getTime();

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                clearInterval(interval);
                setIsLaunched(true);
                setTimeLeft(null);
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((distance / (1000 * 60)) % 60);
            const seconds = Math.floor((distance / 1000) % 60);

            setTimeLeft({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const handleDownloadQR = () => {
        const link = document.createElement('a');
        const qrSrc = existingReg
            ? (existingReg.registrationFee === 1099 ? QR1099 : QR1199)
            : (REG_FEE === 1099 ? QR1099 : QR1199);

        link.href = qrSrc;
        link.download = 'RRC-GCash-QR.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [personalInfo, setPersonalInfo] = useState({
        fullName: user?.realName || "",
        email: user?.email || "",
        contactNumber: ''
    });

    const [jerseyForm, setJerseyForm] = useState({
        items: [{ size: '', name: '', type: 'Mandatory' }],
        gcashRef: ''
    });

    useEffect(() => {
        const checkRegistration = async () => {
            if (!user?.uid) return;

            setChecking(true);
            try {
                const q = query(
                    collection(db, "registrations"),
                    where("submittedBy", "==", user.uid),
                    orderBy("createdAt", "desc")
                );

                const snap = await getDocs(q);

                if (!snap.empty) {
                    const doc = snap.docs[0];
                    if (doc.data().isDeleted !== true) {
                        setExistingReg({ id: doc.id, ...doc.data() });
                        setStep(5);
                    }
                }
            } catch (err) {
                console.error("Error checking registration:", err);
            } finally {
                setChecking(false);
            }
        };
        setLevel(user?.level ? `Level ${levels[user?.level - 1]}` : "");

        setPersonalInfo({
            fullName: user?.realName || "",
            email: user?.email || "",
            contactNumber: ""
        });
        checkRegistration();
    }, [user]);

    const getRegistrationDetails = () => {
        const today = new Date();
        const earlyStart = new Date("2026-03-17");
        const earlyEnd = new Date("2026-04-16");
        const regularStart = new Date("2026-04-17");
        const regularEnd = new Date("2026-04-30");

        if (today >= earlyStart && today <= earlyEnd) {
            return { fee: 1099, label: "Early Registration", deadline: earlyEnd, phase: "early" };
        }
        if (today >= regularStart && today <= regularEnd) {
            return { fee: 1199, label: "Regular Registration", deadline: regularEnd, phase: "regular" };
        }
        return { fee: 1199, label: "Closed / Late", deadline: regularEnd, phase: "closed" };
    };

    const submitPayment = async () => {
        if (!gcashRefInput.trim()) {
            setPayError("Reference number required");
            return;
        }

        setPayLoading(true);
        setPayError("");

        try {
            await updateDoc(doc(db, "registrations", existingReg.id), {
                paymentStatus: "pending_verification",
                gcashReference: gcashRefInput,
                paidAt: serverTimestamp()
            });

            setExistingReg(prev => ({
                ...prev,
                paymentStatus: "pending_verification",
                gcashReference: gcashRefInput
            }));
        } catch (err) {
            console.error(err);
            setPayError("Payment update failed");
        } finally {
            setPayLoading(false);
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString("en-PH", {
            month: "long",
            day: "numeric"
        });
    };

    const validateStep = () => {
        let newErrors = {};
        if (step === 1 && !level) newErrors.level = "Please select your skill level";

        if (step === 2) {
            if (!personalInfo.fullName.trim()) newErrors.fullName = "Full name is required";
            if (!/^\S+@\S+\.\S+$/.test(personalInfo.email)) newErrors.email = "Invalid email format";
            if (personalInfo.contactNumber.length < 10) newErrors.contact = "Invalid contact number";
        }

        if (step === 3) {
            const invalidItem = jerseyForm.items.find(item => !item.name.trim() || !item.size);
            if (invalidItem) newErrors.jersey = "Please complete all jersey details (name and size)";
        }

        if (step === 4) {
            if (paymentMethod === 'now' && !jerseyForm.gcashRef.trim()) {
                newErrors.gcash = "Reference number required for immediate payment";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const next = () => { if (validateStep()) setStep(s => s + 1); };
    const prev = () => { setErrors({}); setStep(s => s - 1); };

    const submitRegistration = async () => {
        if (regloading) return;
        let newErrors = {};
        if (step === 4) {
            if (paymentMethod === 'now' && !jerseyForm.gcashRef.trim()) {
                newErrors.gcash = "Reference number required for immediate payment";
                setErrors(newErrors);
                return;
            }
        }

        setregLoading(true);

        try {
            await addDoc(collection(db, "registrations"), {
                level,
                personalInfo,
                jerseyForm,
                paymentMethod,
                total,
                registrationType: REG_LABEL,
                registrationFee: REG_FEE,
                paymentStatus: paymentMethod === "now" ? "pending_verification" : "unpaid",
                gcashReference: paymentMethod === "now" ? jerseyForm.gcashRef : null,
                paidAt: paymentMethod === "now" ? serverTimestamp() : null,
                submittedBy: user.uid,
                createdAt: serverTimestamp(),
            });

            setStep(5);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setregLoading(false);
        }
    };

    const regDetails = getRegistrationDetails();
    const DEADLINE = formatDate(regDetails.deadline);
    const PHASE = regDetails.phase;
    const REG_FEE = regDetails.fee;
    const REG_LABEL = regDetails.label;
    const EXTRA_J = 750;
    const total = REG_FEE + ((jerseyForm.items.length - 1) * EXTRA_J);
    const peso = (n) => `₱${n.toLocaleString()}`;

    if (loading) {
        return (
            <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "var(--app-bg)", opacity: 0.9 }}>
                <div className="spinner-border" style={{ color: THEME_COLOR }} />
            </div>
        );
    }

    if (!user) {
        return (
            <AuthLanding
                themeColor={THEME_COLOR}
                loggingIn={loggingIn}
                onGoogleLogin={async () => {
                    setLoggingIn(true);
                    try {
                        await loginGoogle();
                    } catch (e) {
                        ToastShow("error", "Login failed. Please try again.");
                    } finally {
                        setLoggingIn(false);
                    }
                }}
            />
        );
    }

    if (checking) {
        return (
            <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "var(--app-bg)", opacity: 0.9 }}>
                <div className="spinner-border" style={{ color: THEME_COLOR }} />
            </div>
        );
    }

    return (
        <div className="min-vh-100 pb-5" style={{ backgroundColor: "var(--app-bg)" }}>
            <AppHeader
                user={user}
                title={"Sibol"}
                subtitle={"Pangalawang Yugto"}
                clubId={CLUB_ID}
                sessionId={null}
                logout={logout}
            />

            <div className="sibol-theme-wrapper">
                <video autoPlay muted loop playsInline className="sibol-video-bg">
                    <source src={VideoBG} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <FloatingBloom />

                <div className="container position-relative py-5" style={{ zIndex: 2 }}>
                    <header className="text-center pb-4" style={{ marginBottom: '1px', marginTop: '-40px' }}>
                        <img src="/img/rrc.png" alt="RRC" className="rrc-main-logo mb-2" />
                        <h1><img src={Sibol} alt="RRC" className="rrc-main-logo mb-2" /></h1>
                    </header>

                    {/* FIXED POST EVENT WINNERS SECTION */}
                    <div className="container-fluid container-md mb-5 px-2 px-sm-3">
                        {/* Overhauled Container: Deep Obsidian base with high-end ambient backdrop blur */}
                        <div className="glass-card p-3 p-sm-4 p-md-5 position-relative shadow-lg border rounded-4 bg-dark bg-opacity-50"
                            style={{
                                backdropFilter: 'blur(24px)',
                                WebkitBackdropFilter: 'blur(24px)',
                                border: '1px solid rgba(255, 255, 255, 0.06)',
                                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)'
                            }}>

                            {/* Subtle Ambient Top Glow */}
                            <div className="position-absolute top-0 start-50 translate-middle-x rounded-circle"
                                style={{ width: '200px', height: '200px', background: 'radial-gradient(circle, rgba(181, 124, 255, 0.15) 0%, rgba(0,0,0,0) 70%)', zIndex: 0, pointerEvents: 'none' }}></div>

                            {/* Section Header */}
                            <div className="text-center mb-4 mb-md-5 position-relative" style={{ zIndex: 1 }}>
                                <div className="logo-wrapper mb-2 mb-md-3 position-relative d-inline-block">
                                    <img src={SibolIcon} alt="Sibol" className="floating-logo img-fluid" style={{ maxHeight: '70px', filter: 'drop-shadow(0 0 12px rgba(181, 124, 255, 0.4))' }} />
                                </div>
                                <div className="mt-2">
                                    <span className="d-inline-block text-warning font-monospace text-uppercase fw-bold animate-pulse"
                                        style={{ fontSize: '0.65rem', letterSpacing: '0.25em', textShadow: '0 0 10px rgba(255, 193, 7, 0.3)' }}>
                                        ✦ Official Final Results ✦
                                    </span>
                                </div>
                                <h2 className="text-white mt-2 mb-1 tracking-tight fs-4 fs-md-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif', fontWeight: 900 }}>
                                    Sibol: Pangalawang Yugto Winners
                                </h2>
                                <p className="premium-subtitle text-white-50 small px-3 font-monospace" style={{ fontSize: '0.75rem', opacity: 0.7 }}>
                                    CONGRATULATIONS TO ALL CHAMPIONS, FINALISTS, AND PARTICIPATING TEAMS.
                                </p>
                            </div>

                            {/* TEAM WINNERS PODIUM */}
                            <div className="mb-5 position-relative" style={{ zIndex: 1 }}>
                                <h4 className="fw-bold text-center mb-4 text-uppercase tracking-widest text-white-50" style={{ fontSize: '0.75rem', letterSpacing: '0.3em' }}>
                // TEAM STANDINGS
                                </h4>
                                <div className="row g-3 g-md-4 justify-content-center">

                                    {/* Champion Card */}
                                    <div className="col-12 col-md-6 col-xl-5">
                                        <div className="winner-card champion p-3 p-md-4 rounded-4 h-100 border position-relative overflow-hidden"
                                            style={{
                                                background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.07) 0%, rgba(255, 193, 7, 0.02) 100%)',
                                                borderColor: 'rgba(255, 193, 7, 0.25)',
                                                boxShadow: 'inset 0 0 20px rgba(255, 193, 7, 0.05)'
                                            }}>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <span className="badge bg-warning text-dark fw-bold px-3 py-2 rounded-2 text-uppercase font-monospace" style={{ fontSize: '0.65rem', letterSpacing: '0.05em' }}>
                                                    🏆 CHAMPION TEAM
                                                </span>
                                                <span className="font-monospace text-warning small fw-bold opacity-70">1st PLACE</span>
                                            </div>
                                            <h3 className="text-warning mb-3 tracking-tight fs-3" style={{ fontWeight: 900 }}>
                                                Team KALACHUCHI
                                            </h3>

                                            {/* Premium Grid Roster formatting */}
                                            <div className="p-3 rounded-3 small text-white-50 lh-base font-monospace" style={{ background: 'rgba(0, 0, 0, 0.25)', border: '1px solid rgba(255,255,255,0.04)' }}>
                                                <div className="row g-3" style={{ fontSize: '0.72rem' }}>
                                                    {/* Column 1 / Left Side: Higher Flights (Div A - C) */}
                                                    <div className="col-12 mt-2 pt-2 border-top border-white border-opacity-10">
                                                        <div className="d-flex align-items-center justify-content-between pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Kean Johan & Dane Leyva</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV A</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-md-12 d-flex flex-column gap-2">

                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Allen Aquino &<br />Marcus Antonius</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV B ☆</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Ryss &<br />Jhoven</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV C1</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Christian M. &<br />Jhazz</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV C2</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">Eiron Dela Cruz &<br />Kenjiro Caneta</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV D ★</span>
                                                        </div>
                                                    </div>

                                                    {/* Column 2 / Right Side: Lower Flights (Div D - G) */}
                                                    <div className="col-6 col-md-12 d-flex flex-column gap-2">

                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Andrelle Lim &<br />Christian Tarroza</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV E1 ☆</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Jan Henri Vigo &<br />Hyren Dulay</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV E2 ☆</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">Jaya Solomon &<br />Emman Catindoy</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV F ★</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Em Morats &<br />Charles Lanang</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV G</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {/* Runner Up Card */}
                                    <div className="col-12 col-md-6 col-xl-5">
                                        <div className="winner-card p-3 p-md-4 rounded-4 h-100 border position-relative overflow-hidden"
                                            style={{
                                                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%)',
                                                borderColor: 'rgba(255, 255, 255, 0.1)'
                                            }}>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <span className="badge bg-secondary bg-opacity-25 text-white-50 fw-bold px-3 py-2 rounded-2 text-uppercase font-monospace" style={{ fontSize: '0.65rem', letterSpacing: '0.05em', border: '1px solid rgba(255,255,255,0.1)' }}>
                                                    🥈 RUNNER UP
                                                </span>
                                                <span className="text-info font-monospace small text-truncate fw-bold" style={{ color: '#e2e8f0' }}>2nd PLACE</span>
                                            </div>
                                            <h3 className="text-white mb-3 tracking-tight fs-3 opacity-90" style={{ fontWeight: 900 }}>
                                                Team SAMPAGUITA
                                            </h3>

                                            <div className="p-3 rounded-3 small text-white-50 lh-base font-monospace" style={{ background: 'rgba(0, 0, 0, 0.25)', border: '1px solid rgba(255,255,255,0.04)' }}>
                                                <div className="row g-3" style={{ fontSize: '0.72rem' }}>
                                                    <div className="col-12 mt-2 pt-2 border-top border-white border-opacity-10">
                                                        <div className="d-flex align-items-center justify-content-between pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">PJ Espartinez & John Chan</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV A ★</span>
                                                        </div>
                                                    </div>
                                                    {/* Column 1 / Left Side: Higher Flights (Div A - C) */}
                                                    <div className="col-6 col-md-12 d-flex flex-column gap-2">

                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">Kerr Isberto &<br />Jonel</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV B ★</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">Steven Quinto &<br />James Bontia</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV C1 ★</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Christian M. &<br />Sharlene Anday</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV C2 ☆</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Adolf Pangan &<br />Daniel John Ibit</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV D ☆</span>
                                                        </div>
                                                    </div>

                                                    {/* Column 2 / Right Side: Lower Flights (Div D - G) */}
                                                    <div className="col-6 col-md-12 d-flex flex-column gap-2">

                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate fw-bold text-warning">Mon Deoferio &<br />JM Belarmino</span>
                                                            <span className="badge bg-warning bg-opacity-10 text-warning ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,193,7,0.2)' }}>DIV E1 ★</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Aldrich Ramirez &<br />Marck Esguerra</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV E2</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            {/* Fixed spelling to Diane Chanco & highlighted as a division runner-up */}
                                                            <span className="text-info opacity-90 text-truncate fw-bold" style={{ color: '#e2e8f0' }}>Kyle Salen &<br />Diane Chanco</span>
                                                            <span className="badge bg-secondary bg-opacity-25 text-white-50 ms-1" style={{ fontSize: '0.55rem', border: '1px solid rgba(255,255,255,0.15)' }}>DIV F ☆</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom border-white border-opacity-5 pb-1">
                                                            <span className="text-white opacity-90 text-truncate">Laurence M. &<br />Marielle Mendoza</span>
                                                            <span className="badge bg-white bg-opacity-10 text-white-50 ms-1" style={{ fontSize: '0.55rem' }}>DIV G</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <hr className="my-4 my-md-5" style={{ borderColor: 'rgba(255,255,255,0.08)' }} />

                            {/* LEVEL WINNERS GRID / APP SWIPER */}
                            <div className="position-relative" style={{ zIndex: 1 }}>
                                <h4 className="fw-bold text-center mb-4 text-uppercase tracking-widest text-white-50" style={{ fontSize: '0.75rem', letterSpacing: '0.3em' }}>
                // DIVISIONAL BRACKETS
                                </h4>

                                {/* Custom app-like native scrolling view layer with dynamic hide-scrollbar rules */}
                                <div className="d-flex flex-nowrap overflow-x-auto pb-3 row flex-md-wrap g-3 g-md-4"
                                    style={{
                                        WebkitOverflowScrolling: 'touch',
                                        scrollbarWidth: 'none', /* Firefox */
                                        msOverflowStyle: 'none' /* IE/Edge */
                                    }}>
                                    <style>{`
                    /* Hide Webkit Scrollbars for an immersive app experience on mobile devices */
                    .overflow-x-auto::-webkit-scrollbar { display: none; }
                `}</style>

                                    {[
                                        { level: "A", champion: "PJ Joshua Espartinez & John Chan", runner: "CJ Santos & Arzel Badilla" },
                                        { level: "B", champion: "Kerr Isberto & Jonel", runner: "Allen Aquino & Marcus Antonius" },
                                        { level: "C1", champion: "Steven Quinto & James Bontia", runner: "Lovely Ladi & Ino Barrientos" },
                                        { level: "C2", champion: "John Lopez & Mikay Manalo", runner: "Christian Marbella & Sharlene Anday" },
                                        { level: "D", champion: "Eiron Dela Cruz & Kenjiro Caneta", runner: "Adolf Pangan & Daniel John Ibit" },
                                        { level: "E1", champion: "Mon Deoferio & JM Belarmino", runner: "Andrelle Lim & Christian Tarroza" },
                                        { level: "E2", champion: "Bryan Angelo Martinez & Anderson Silva", runner: "Jan Henri Vigo & Hyren Dulay" },
                                        { level: "F", champion: "Jaya Solomon & Emman Catindoy", runner: "Diane Chanco & Kyle Salen" },
                                        { level: "G", champion: "Vanie Manalo & Kim Jasmine", runner: "Mark Paner & Elizabeth Valenton" }
                                    ].map((item, index) => (
                                        <div className="col-10 col-sm-6 col-md-6 col-lg-4 flex-shrink-0 flex-md-shrink-1" key={index}>
                                            <div className="winner-card p-3 p-md-4 rounded-3 h-100 border d-flex flex-column justify-content-between"
                                                style={{
                                                    background: 'rgba(0, 0, 0, 0.2)',
                                                    borderColor: 'rgba(255, 255, 255, 0.05)'
                                                }}>
                                                <div>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="badge px-3 py-2 text-uppercase fw-bold font-monospace text-white"
                                                            style={{ fontSize: '0.6rem', color: '#b57cff', background: 'rgba(181, 124, 255, 0.12)', border: '1px solid rgba(181, 124, 255, 0.2)' }}>
                                                            DIV {item.level}
                                                        </span>
                                                        <span className="text-white-50 font-monospace" style={{ fontSize: '0.6rem' }}>⚡ FINAL</span>
                                                    </div>
                                                    <div className="mb-2">
                                                        <small className="text-white-50 d-block text-uppercase tracking-wider font-monospace opacity-90" style={{ fontSize: '0.7rem' }}>🥇 CHAMPION</small>
                                                        <span className="fw-bold text-white text-truncate d-block opacity-90" style={{ fontSize: '0.85rem' }}>{item.champion}</span>
                                                    </div>
                                                    <div className="pt-1">
                                                        <small className="text-white-50 d-block text-uppercase tracking-wider font-monospace opacity-90" style={{ fontSize: '0.7rem' }}>🥈 RUNNER-UP</small>
                                                        <span className="text-white-50 small text-truncate d-block opacity-70" style={{ fontSize: '0.8rem' }}>{item.runner}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>


                    {!eventEnded && (
                        <>
                            {!existingReg && !isLaunched && !isRegistrationClosed && (
                                <div className="container mt-5 d-flex justify-content-center px-4 mb-5">
                                    <div className="premium-glass-card animate-fade-in text-center py-5">
                                        {timeLeft && (
                                            <div className="mt-4">
                                                <div className="d-flex justify-content-center gap-3 text-white fw-bold">
                                                    <div>
                                                        <div className="fs-3">{timeLeft.days}</div>
                                                        <small>Days</small>
                                                    </div>
                                                    <div>
                                                        <div className="fs-3">{timeLeft.hours}</div>
                                                        <small>Hours</small>
                                                    </div>
                                                    <div>
                                                        <div className="fs-3">{timeLeft.minutes}</div>
                                                        <small>Min</small>
                                                    </div>
                                                    <div>
                                                        <div className="fs-3">{timeLeft.seconds}</div>
                                                        <small>Sec</small>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <hr />
                                        <div className="logo-wrapper mb-4">
                                            <img src={SibolIcon} alt="Sibol" className="floating-logo" />
                                            <div className="success-ring opacity-25"></div>
                                        </div>
                                        <h2 className="fw-900 tracking-tight m-0 text-white">Coming Soon</h2>
                                        <p className="premium-subtitle px-3 mt-2">
                                            🌸 <strong>Sibol: Pangalawang Yugto</strong> registration is opening soon.
                                        </p>
                                        <div className="mt-4 pt-2">
                                            <div className="status-badge-premium unpaid d-inline-block">
                                                Launching Soon 🚀
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {existingReg && isLaunched && (
                                <div className="container mt-5 d-flex justify-content-center px-4 mb-5">
                                    <div className="premium-glass-card animate-fade-in">
                                        <div className="text-center mb-4">
                                            <div className="logo-wrapper mb-3">
                                                <img src={SibolIcon} alt="RRC" className="floating-logo" />
                                                <div className="success-ring"></div>
                                            </div>
                                            <h2 className="fw-900 tracking-tight m-0">Registration Active</h2>
                                            <p className="premium-subtitle">You are already registered for this event.</p>
                                        </div>

                                        <div className="stats-bento mb-4">
                                            <div className="bento-item main">
                                                <span className="bento-label">Player</span>
                                                <div className="bento-value">{existingReg.personalInfo?.fullName}</div>
                                            </div>
                                            <div className="bento-item">
                                                <span className="bento-label">Level</span>
                                                <div className="bento-value text-purple-sibol">{existingReg.level}</div>
                                            </div>
                                            <div className="bento-item">
                                                <span className="bento-label">Jersey</span>
                                                <div className="bento-value">{existingReg.jerseyForm?.items[0]?.name}</div>
                                                <div className="bento-value">{existingReg.jerseyForm?.items[0]?.size}</div>
                                            </div>
                                            <div className="bento-item">
                                                <span className="bento-label">Fee</span>
                                                <div className="bento-value">{peso(existingReg.registrationFee)}</div>
                                            </div>
                                            <div className="bento-item">
                                                <span className="bento-label">Status</span>
                                                <div className={`status-badge-premium ${existingReg.paymentStatus}`}>
                                                    {existingReg.paymentStatus?.replace('_', ' ')}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="action-area">
                                            {existingReg.paymentStatus === "unpaid" && (
                                                <div className="gcash-payment-card p-3 animate-fade-in">
                                                    <div className="d-flex align-items-center gap-2 mb-3">
                                                        <div className="gcash-dot"></div>
                                                        <span className="small fw-bold opacity-75">GCASH PAYMENT</span>
                                                    </div>
                                                    <div className="payment-details mb-3">
                                                        <div className="d-flex justify-content-between">
                                                            <span className="opacity-50 small">Receiver</span>
                                                            <span className="fw-bold small text-white">{gcashName}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-1 mb-3">
                                                            <span className="opacity-50 small">Account</span>
                                                            <span className="fw-bold small text-white">
                                                                {gcashNum}
                                                                <button
                                                                    className="btn btn-sm px-2 py-1 border-0 bg-white bg-opacity-10 text-white rounded-2 ms-2"
                                                                    onClick={() => {
                                                                        navigator.clipboard.writeText(gcashNum);
                                                                        ToastShow('success', 'GCash number copied');
                                                                    }}
                                                                >
                                                                    <i className="bi bi-clipboard"></i>
                                                                </button>
                                                            </span>
                                                        </div>
                                                        <button className="btn-qr-save w-100 d-flex align-items-center justify-content-center gap-2" onClick={() => setShowQRModal(true)}>
                                                            <i className="bi bi-qr-code-scan"></i>
                                                            <span>Save QR Code</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <BottomNav activeTab="home" />
        </div>
    );
}

